export function isStockBalanceColumnSortingChanged(currentOrdering, ascending, descending) {
    const currentValuesAreEqualToNew = (currentOrdering === 'asc' && ascending) ||
        (currentOrdering === 'desc' && descending) ||
        (currentOrdering === null && !ascending && !descending);
    return !currentValuesAreEqualToNew;
}
